"use client";

import { useGeoLocation } from "@/lib/hooks/useGeoLocation";
import {
  AMAZON_SIGNAGE_STICK_US_BUY_URL,
  getAmazonSignageStickBuyUrl,
} from "@/lib/amazon-signage-stick-buy-url";

/**
 * Resolves the Amazon Signage Stick purchase URL for the visitor's country.
 * Falls back to the US marketplace while loading or for unmatched countries.
 */
export function useAmazonSignageStickBuyUrl() {
  const { geoData, isLoading } = useGeoLocation();
  const href = isLoading
    ? AMAZON_SIGNAGE_STICK_US_BUY_URL
    : getAmazonSignageStickBuyUrl(geoData?.countryCode);

  return { href, isLoading };
}
